"use client";
// Basic placeholder for FullPageLoadingIcon
const FullPageLoadingIcon = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        position: "fixed",
        top: 0,
        left: 0,
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        zIndex: 9999,
      }}
    >
      <div className="fa fa-spinner fa-spin fa-3x"></div>{" "}
      {/* Assuming FontAwesome */}
      <span style={{ marginLeft: "10px", fontSize: "1.5rem" }}>Loading...</span>
    </div>
  );
};

export default FullPageLoadingIcon;
